import { render, staticRenderFns } from "./ListSkills.vue?vue&type=template&id=72228458&scoped=true&"
import script from "./ListSkills.vue?vue&type=script&lang=js&"
export * from "./ListSkills.vue?vue&type=script&lang=js&"
import style0 from "./ListSkills.vue?vue&type=style&index=0&id=72228458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72228458",
  null
  
)

export default component.exports